import { useAuth } from '@/app/providers/AuthProvider';
import { primaryRole, ROLE_LABELS } from '@/lib/auth/capabilities';
import { ErrorPage } from './ErrorPage';

/**
 * A route the user is authenticated for but not authorised for.
 *
 * Naming the role they *do* hold is the difference between a dead end and an
 * actionable message: a reviewer who lands on the catalogue needs to know they are
 * a reviewer, not that "access is denied". It discloses nothing — the roles are
 * their own, and the app already renders them in the account menu.
 *
 * This page is presentation only. The server refuses the same request
 * independently; hiding the route is a courtesy, not the control.
 */
export function ForbiddenPage() {
  const { capabilities } = useAuth();
  const role = primaryRole(capabilities.roles);

  return (
    <ErrorPage
      code="403"
      title="You do not have access to this area"
      detail={
        role === null
          ? 'This account has no roles assigned yet. An administrator has to grant one before you can use the workspace.'
          : `You are signed in as ${ROLE_LABELS[role]}, which does not include this area. An administrator can grant the role that does.`
      }
    />
  );
}
